import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: localStorage.getItem('portalToken'),
  isAuthenticated: !!localStorage.getItem('portalToken'),
  user: localStorage.getItem('portalUser') ? JSON.parse(localStorage.getItem('portalUser')) : null,
  loading: false,
  error: null,
};

const portalAuthSlice = createSlice({
  name: 'portalAuth',
  initialState,
  reducers: {
    portalLoginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    portalLoginSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.error = null;

      localStorage.setItem('portalToken', action.payload.token);
      localStorage.setItem('portalUser', JSON.stringify(action.payload.user));
    },
    portalLoginFailure: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      state.error = action.payload || 'Portal authentication failed';

      localStorage.removeItem('portalToken');
      localStorage.removeItem('portalUser');
    },
    portalSetUser: (state, action) => {
      state.user = action.payload;
      localStorage.setItem('portalUser', JSON.stringify(action.payload));
    },
    portalLogout: (state) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      state.error = null;

      localStorage.removeItem('portalToken');
      localStorage.removeItem('portalUser');
    },
  },
});

export const {
  portalLoginStart,
  portalLoginSuccess,
  portalLoginFailure,
  portalSetUser,
  portalLogout,
} = portalAuthSlice.actions;

export default portalAuthSlice.reducer;
